import { render } from "./legend.vue?vue&type=template&id=4a3af88c&scoped=true"
const script = {}

import "./legend.vue?vue&type=style&index=0&id=4a3af88c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3af88c"]])

export default __exports__